import type { News } from "@/types/content";

export const news: News[] = [
  {
    id: "n1",
    title: "《继母的诱惑》十年回顾：为什么它依然是家庭剧的标杆",
    date: "2020-07-20",
    tag: "深度回顾",
    summary: "播出十年后，《继母的诱惑》仍被反复讨论。它用克制的笔触，写尽了家族、信任与救赎。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Editorial%20retrospective%20still%20of%20a%20grand%20dim%20mansion%20facade%20at%20dusk%20with%20warm%20lit%20windows%2C%20moody%20deep%20blue%20sky%2C%20cinematic%20melodrama%20atmosphere%2C%20film%20grain&width=800&height=600&seq=news-01&orientation=landscape",
    paragraphs: [
      "作为一部以家族恩怨为主线的情感剧，《继母的诱惑》最动人的地方，恰恰是它没有把任何人写成纯粹的坏人。",
      "剧中每一个人物都在为自己的立场而努力：瑟琪为加人、为旧案；志勋为原则、为母亲；就连婉婷，也有她作为\"半个姜家人\"却始终不被承认的委屈。",
      "正是这种复杂性，让这部作品在播出十年后依然被观众反复回味，被视为家庭题材剧集的一份样本。",
    ],
    newsIds: ["n4", "n8"],
  },
  {
    id: "n2",
    title: "金道贤谈姜志勋：他所有的克制，都是防御",
    date: "2020-07-02",
    tag: "演员专访",
    summary: "饰演姜志勋的金道贤在专访中分享了他对角色的理解——冷硬外壳下，是一个害怕再次失去的人。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20scene%20of%20a%20male%20actor%20seated%20in%20a%20dim%20interview%20room%2C%20microphone%20and%20soft%20key%20light%2C%20moody%20dark%20blue%20background%2C%20cinematic%20tone%2C%20film%20grain&width=800&height=600&seq=news-02&orientation=landscape",
    paragraphs: [
      "\"志勋这个角色最难的地方，是他永远不能把情绪写在脸上。\"金道贤坦言，为了演好姜志勋，他花了很长时间去理解\"沉默\"这件事。",
      "在他看来，志勋对继母的敌意，本质上是恐惧——他害怕再一次被至亲的人抛下。",
      "谈及大结局那场雪夜戏，金道贤说，那一条他几乎没有演，只是站在那里，让所有积压的情绪自然流出来。",
    ],
    newsIds: ["n5", "n1"],
  },
  {
    id: "n3",
    title: "白婉婷为什么让人恨不起来？反派的复杂写法",
    date: "2020-06-25",
    tag: "角色解析",
    summary: "作为全剧最大的对手，白婉婷却在观众中人气居高不下。这篇解析带你看懂这位\"体面反派\"。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20of%20an%20elegant%20ambitious%20woman%20standing%20alone%20in%20a%20dim%20boardroom%20looking%20out%20of%20a%20window%2C%20cold%20blue%20light%2C%20lonely%20tone%2C%20cinematic%20melodrama%20film%20grain&width=800&height=600&seq=news-03&orientation=landscape",
    paragraphs: [
      "婉婷从不歇斯底里。她永远得体、永远冷静，把算计藏在微笑之后。",
      "但剧中只用几个细节便交代了她的动机：逢年过节，她永远是被排在家族合照边缘的那个人。",
      "当反派的行为有了可信的来处，观众便很难简单地恨她——这或许正是这个角色最成功的地方。",
    ],
    newsIds: ["n6", "n1"],
  },
  {
    id: "n4",
    title: "尹瑟琪的十年：从\"外人\"到\"女主人\"的人物弧光",
    date: "2020-06-18",
    tag: "角色解析",
    summary: "梳理瑟琪在全剧中最重要的五个转折点，看一个角色如何完成从隐忍到掌局的蜕变。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20of%20a%20woman%20in%20a%20navy%20dress%20standing%20at%20the%20top%20of%20a%20grand%20staircase%20looking%20down%2C%20dramatic%20chandelier%20light%2C%20deep%20blue%20and%20gold%20tones%2C%20cinematic%20film%20grain&width=800&height=600&seq=news-04&orientation=landscape",
    paragraphs: [
      "瑟琪的成长，是全剧最清晰的一条线。初入姜家时，她连餐桌上的位置都要被安排。",
      "理事会上的一次反击、雨夜的一次停车、遗嘱启封时的一次沉默——每一个节点都在改变她与这座宅子的关系。",
      "到结局时，她已经不需要任何人的承认，只是安静地站在了自己的位置上。",
    ],
    newsIds: ["n1", "n8"],
  },
  {
    id: "n5",
    title: "雨夜那场戏拍了整整三天：幕后花絮揭秘",
    date: "2020-06-11",
    tag: "幕后花絮",
    summary: "第4集的雨夜戏是全剧名场面之一。剧组为它调来了三辆消防车，演员在低温中连拍三天。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20still%20of%20a%20rain%20machine%20on%20a%20night%20set%20under%20an%20overpass%2C%20film%20crew%20with%20lights%2C%20wet%20asphalt%20reflections%2C%20cool%20blue%20tones%2C%20documentary%20style%20film%20grain&width=800&height=600&seq=news-05&orientation=landscape",
    paragraphs: [
      "\"那晚真的很冷，水打在身上几乎站不住。\"参与拍摄的工作人员回忆，雨夜戏的每一帧都是靠反复走位换来的。",
      "导演坚持不用特效合成雨景，理由是\"真实的重量感是无法画出来的\"。",
      "也正是这份较真，让那把递出去的伞，成了无数观众心中的名场面。",
    ],
    newsIds: ["n2", "n7"],
  },
  {
    id: "n6",
    title: "商战线梳理：姜氏集团与泰成集团的十年暗战",
    date: "2020-06-04",
    tag: "剧情梳理",
    summary: "除了情感主线，剧中穿插的商战线同样精彩。本文带你一次理清两大家族集团的恩怨脉络。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20of%20a%20night%20city%20skyline%20with%20two%20glass%20office%20towers%20facing%20each%20other%2C%20cold%20blue%20lights%2C%20tense%20corporate%20atmosphere%2C%20cinematic%20film%20grain&width=800&height=600&seq=news-06&orientation=landscape",
    paragraphs: [
      "姜氏与泰成的竞争贯穿全剧，从渠道争夺到资本博弈，几乎每一次家族危机背后都有对手的影子。",
      "婉婷引狼入室的结盟，本以为是棋高一着，却低估了对手的野心。",
      "郑泰成在最后关头的反水，既是商业计算，也是老一辈对手之间的一次\"清算\"。",
    ],
    newsIds: ["n3", "n1"],
  },
  {
    id: "n7",
    title: "柳世拉：恩星不是剧里最弱的，她是最勇敢的",
    date: "2020-05-28",
    tag: "演员专访",
    summary: "饰演姜恩星的柳世拉聊了聊这个\"看似天真\"的角色，其实承担了全剧最重要的几次选择。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20scene%20of%20a%20young%20female%20actor%20smiling%20gently%20in%20a%20bright%20but%20softly%20dimmed%20room%2C%20warm%20natural%20light%2C%20muted%20neutral%20background%2C%20cinematic%20tone%2C%20film%20grain&width=800&height=600&seq=news-07&orientation=landscape",
    paragraphs: [
      "\"很多人觉得恩星只是个天真妹妹，但我不这么看。\"柳世拉说，恩星是全剧里少数\"敢直接说不\"的人。",
      "正是她无意间撞破密会、鼓起勇气留下证据，才让剧情有了翻盘的可能。",
      "在柳世拉眼中，恩星守护的从来不是权力，而是\"这个家还值得被相信\"这件事。",
    ],
    newsIds: ["n5", "n3"],
  },
  {
    id: "n8",
    title: "大结局复盘：雪夜、晨光与那扇重新打开的门",
    date: "2020-07-08",
    tag: "剧情梳理",
    summary: "大结局用一场雪与一束晨光收尾。本文复盘结局里的所有伏笔，以及它真正想说的话。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20of%20a%20snowy%20mansion%20courtyard%20at%20dawn%20with%20soft%20falling%20snow%20and%20warm%20glowing%20windows%2C%20hopeful%20golden%20light%20breaking%20through%20cool%20blue%20shadows%2C%20cinematic%20film%20grain&width=800&height=600&seq=news-08&orientation=landscape",
    paragraphs: [
      "从雨夜开始，到雪夜结束。全剧最动人的一组呼应，藏在天气的变化里。",
      "大结局没有盛大的仪式，只有一扇缓缓打开的大门。导演用最安静的方式，完成了对\"家\"这个主题的回答。",
      "\"我们不是走出了恩怨，而是终于学会了带着它继续生活。\"这句台词被许多观众记了很久。",
    ],
    newsIds: ["n1", "n4"],
  },
  {
    id: "n9",
    title: "剧组重聚特辑：十年后再见姜家的每个人",
    date: "2020-07-15",
    tag: "幕后花絮",
    summary: "十年后，主创团队重聚。当他们再次走进那间熟悉的客厅，许多回忆扑面而来。",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20reunion%20still%20of%20a%20film%20cast%20gathered%20in%20a%20warmly%20lit%20living%20set%2C%20cameras%20and%20crew%20around%2C%20nostalgic%20warm%20tone%20against%20soft%20blue%20shadows%2C%20cinematic%20film%20grain&width=800&height=600&seq=news-09&orientation=landscape",
    paragraphs: [
      "重聚特辑里，演员们重新站回当年的位置，连走廊的灯光都还原得一模一样。",
      "\"推开门的瞬间，好像这十年根本没过去。\"一位主演这样形容当时的感受。",
      "特辑的结尾，全体主创在那扇门前合影。门里门外，是故事，也是他们共同的十年。",
    ],
    newsIds: ["n5", "n2"],
  },
];